import React, {Component} from "react";
import {Card, CardTitle, CardText, Button, Row, Col} from 'reactstrap';
import {CALCULATE_RISK, RISK_COLOR} from "../Constants";

export default class Ergonomic  extends Component{

    constructor(props) {
        super(props);
    }


    render(){

        const {
            data,
            model,
            id
        } = this.props;

        const{color} = RISK_COLOR(model.base_line);

        return(
            <div>
                <Card body color={"#eee"}>
                    <Row>
                        <Col>
                            <p className="margin-5">
                                <span className="attribute">Name:</span> <span className="attribute-details">Ergonomic template - {model.name}</span>
                            </p>
                            <p className="margin-5">
                                <span className="attribute">Task ID:</span> <span className="attribute-details">{`${model.risk_id} - ${model.id}`}</span>
                            </p>
                            <p className="margin-5"><span className="attribute">Activity:</span> <span className="attribute-details">{data.activity}</span></p>
                            <p className="margin-5"><span className="attribute">Body Parts: </span><span className="attribute-details">{data.body_parts}</span></p>
                        </Col>
                        <Col>
                            <h6>Health Risk:</h6>
                            <p className="controls">{data.health_risk}</p>
                            <h6>Controls:</h6>
                            <p className="controls">{data.current_controls}</p>
                        </Col>
                    </Row>
                    <hr/>
                    <Row className="rating" style={{backgroundColor: color}}>
                        <Col>
                            <div>
                                <h6>Risk Rating:</h6>
                                <p className="margin-5"><span>Severity:</span> <span>{data.severity}</span></p>
                                <p className="margin-5"><span>Likelihood:</span> <span>{data.likelihood}</span></p>
                            </div>
                        </Col>
                        <Col>
                            <h6>Baseline Risk:</h6>
                            <p className="baseline">{model.base_line}</p>
                        </Col>
                    </Row>
                </Card>
            </div>
        )
    }
}





// WEBPACK FOOTER //
// ./src/screens/risks/lists/Ergonomic.js